/** @jsxImportSource @emotion/react */
export const PlanMessage = () => {
  
  const baseCode = process.env.REACT_APP_CODE;
  
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  
  return (
    <>
      {baseCode === 'ssnb' && (
        <p className="typographyTextSupport typographySecondaryColor recommendedInsuranceItems_guardText">
           ここで表示されているMyプランの内容は、ご入力いただいた各情報を元に算出された必要保障額に対し、当社が定めた基準で算出している内容となっております。 なお、必ずしも表示されている保険料で必要保障額の全てが満たされるとは限りません。その他の条件等によってご提案できる保険料が異なる場合がございますので、詳細につきましては「無料相談・問い合わせ」より当社家計見直しセンターまでお問い合わせください。 また、各保険会社の審査の結果お引き受け出来ない可能性もございますので何卒ご了承ください。 本資料でご案内している保険料に関する内容は、{year}年{month}月2日現在で適用されているものです。
        </p>
      )}
      {baseCode === 'financial-agency' && (
        <p className="typographyTextSupport typographySecondaryColor recommendedInsuranceItems_guardText">
           ここで表示されているMyプランの内容は、ご入力いただいた各情報を元に算出された必要保障額に対し、弊社が定めた基準でおすすめしている商品内容となっております。 なお、必ずしも表示されている保険商品で必要保障額の全てが満たされるとは限りません。また、ここで表示されている情報は、保障内容の全てが記載されているわけではなくあくまで情報の一部となる為、これ以外の保険商品と単純に比較したり優劣をつけたりすることはできません。 実際にご検討いただく際には各保険会社のパンフレット及び、ご契約のしおり、重要事項説明書をご確認ください。 加えて、その他の条件等によってご提案できる商品や保険料が異なる場合がございますので、詳しいことにつきましてはお問い合わせください。 また、各保険会社の審査の結果お引き受け出来ない可能性もございますので何卒ご了承ください。
本資料でご案内している保険商品に関する内容は、{year}年{month}月2日現在で適用されているものです。
        </p>
      )}
      {baseCode === 'faep' && (
        <p className="typographyTextSupport typographySecondaryColor recommendedInsuranceItems_guardText">
           ここで表示されているMyプランの内容は、ご入力いただいた各情報を元に算出された必要保障額に対し、弊社が定めた基準でおすすめしている商品内容となっております。 なお、必ずしも表示されている保険商品で必要保障額の全てが満たされるとは限りません。また、ここで表示されている情報は、保障内容の全てが記載されているわけではなくあくまで情報の一部となる為、これ以外の保険商品と単純に比較したり優劣をつけたりすることはできません。 実際にご検討いただく際には各保険会社のパンフレット及び、ご契約のしおり、重要事項説明書をご確認ください。 加えて、その他の条件等によってご提案できる商品や保険料が異なる場合がございますので、詳しいことにつきましてはお問い合わせください。 また、各保険会社の審査の結果お引き受け出来ない可能性もございますので何卒ご了承ください。
本資料でご案内している保険商品に関する内容は、{year}年{month}月2日現在で適用されているものです。
        </p>
      )}
      {baseCode === 'test' && (
        <p className="typographyTextSupport typographySecondaryColor recommendedInsuranceItems_guardText">
    ここで表示されているMyプランの内容は、ご入力いただいた各情報を元に算出された必要保障額に対し、弊社が定めた基準でおすすめしている商品内容となっております。 なお、必ずしも表示されている保険商品で必要保障額の全てが満たされるとは限りません。テスト領域での表示となります。{year}年{month}月
        </p>
      )}
    </>
  );
};
export default PlanMessage;
